<template>
  <v-card v-if="dialog" class="site-interface">
    <v-card-title class="interface-title mb-4">
      Gestion des {{ mode === 'user' ? 'sites' : 'utilisateurs' }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" large class="close-icon" @click="close()">
            close
          </v-icon>
        </template>
        Fermer
      </v-tooltip>
    </v-card-title>
    <v-card-subtitle class="interface-subtitle">
      <v-icon large>{{ mode === 'user' ? 'person' : 'home_work' }}</v-icon>
      {{
        mode === 'user'
          ? `${dialog.user.firstName} ${dialog.user.lastName.toUpperCase()}`
          : dialog.site.refSite.nom
      }}
    </v-card-subtitle>
    <v-card-text v-if="mode === 'user'">
      <site-interface-editor
        v-if="dialog.editing"
        :user="dialog.user"
        :data-table-key="dataTableKey"
        :headers="editorHeaders"
        @cancel-edit="cancelEdit()"
        @update="$emit('update')"
      />
      <site-interface-viewer
        v-else
        :user="dialog.user"
        :data-table-key="dataTableKey"
        :headers="viewerHeaders"
        @edit="edit()"
      />
    </v-card-text>
    <v-card-text v-else>
      <site-interface-editor
        v-if="dialog.editing"
        :site="dialog.site"
        :data-table-key="dataTableKey"
        :headers="editorHeaders"
        @cancel-edit="cancelEdit()"
        @update="$emit('update')"
      />
      <site-interface-viewer
        v-else
        :site="dialog.site"
        :data-table-key="dataTableKey"
        :headers="viewerHeaders"
        @edit="edit()"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import SiteInterfaceEditor from './SiteInterfaceEditor';
import SiteInterfaceViewer from './SiteInterfaceViewer';

const viewerHeaders = [
  { text: 'Code', value: 'refSite.code' },
  { text: 'Nom', value: 'refSite.nom' },
  { text: 'Type', value: 'typeName' },
  {
    text: 'Section',
    value: 'sectionName',
  },
  {
    text: 'Région',
    value: 'regionName',
  },
  {
    text: 'Société',
    value: 'societeName',
  },
];

const editorHeaders = [
  { text: 'Code', value: 'refSite.code' },
  { text: 'Nom', value: 'refSite.nom' },
  {
    text: 'Section',
    value: 'sectionName',
  },
  {
    text: 'Région',
    value: 'regionName',
  },
  {
    text: 'Société',
    value: 'societeName',
  },
];

const siteViewerHeaders = [
  { text: 'Email', value: 'email' },
  { text: 'Nom', value: 'lastName' },
  { text: 'Prénom', value: 'firstName' },
];

const actionHeader = { text: 'Action', value: 'action', align: 'center' };

export default {
  name: 'site-interface',
  components: {
    SiteInterfaceEditor,
    SiteInterfaceViewer,
  },
  props: {
    dialog: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'user',
    },
  },
  data() {
    if (this.mode === 'user') {
      return {
        dataTableKey: 'refSite.id',
        editing: false,
        viewerHeaders: viewerHeaders,
        // editorHeaders: [...viewerHeaders, actionHeader],
        editorHeaders: [...editorHeaders, actionHeader],
      };
    }
    return {
      dataTableKey: 'email',
      editing: false,
      viewerHeaders: siteViewerHeaders,
      editorHeaders: [...siteViewerHeaders, actionHeader],
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    edit() {
      this.$emit('edit');
    },
    cancelEdit() {
      this.$emit('cancel-edit');
    },
  },
};
</script>

<style lang="scss" scoped>
.site-interface {
  min-height: 360px;

  .interface-title {
    color: #f49100;
  }

  .close-icon {
    color: #f49100;
    display: block;
    position: absolute;
    right: 8px;
    top: 12px;
    transform: scale(1);
    transition: transform 0.1s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .interface-subtitle {
    font-size: 18px;
  }
}
</style>
